import { useEffect } from 'react';
import { useLatest } from 'ahooks';
import { SEARCH_SELECT_COMP_AUTO_CLOSE_WHEN_SCROLL_NODE } from '@gp/constants/classNames';

export default function useCloseSearchBoxDropdownWhenScroll(close: () => void) {
  const closeLatest = useLatest(close);

  const handleScroll = () => {
    closeLatest.current?.();
  };

  useEffect(() => {
    let el: Element | null = null;

    let timer: NodeJS.Timeout | null = setInterval(() => {
      el = document.querySelector(`.${SEARCH_SELECT_COMP_AUTO_CLOSE_WHEN_SCROLL_NODE}`);
      if (el) {
        el.addEventListener('scroll', handleScroll);
        clearInterval(timer as NodeJS.Timeout);
      }
    }, 100);

    return () => {
      if (el) {
        el.removeEventListener('scroll', handleScroll);
        el = null;
      }

      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
  }, []);
}
